runOnLoad "Search", [ "new", "create" ], ->

  SegmentationBuilder.setup()

  $(document).on "click", ".show-subscriber-list-segment .control-line a", ->
    $link      = $(this)
    $container = $link.closest(".show-subscriber-list-segment")
    $segment   = $container.find(".segmentation-criteria-container")
    showOrHide = if $segment.is(":visible") then "show" else "hide"
    linkText   = t("buttons.#{showOrHide}_segmentation_criteria")

    $segment.slideToggle()
    $link.text(linkText)

    return false
